import { TECHNOLOGIES_TABLE_URL } from "app/pages/website-analysis/website-technologies/constants/constants";
import type { TechnologyItem } from "app/pages/workspace/sales/sub-modules/feed/types/technologies";
import { DefaultFetchService } from "app/services/fetchService";

const fetchService = DefaultFetchService.getInstance();

export async function fetchSiteTechnologies(keys: string[]): Promise<TechnologyItem[]> {
    const url = new URL(`${window.origin}${TECHNOLOGIES_TABLE_URL}`);
    url.searchParams.append("keys", keys.join(","));
    url.searchParams.append("showOnlyPresented", `${keys.length > 1}`);
    return fetchService.get<TechnologyItem[]>(url.toString());
}

export const technologiesExcelUrl = (keys: string[]) =>
    `/api/technographics/excel?keys=${keys.map(encodeURIComponent)}`;
